// extracted by mini-css-extract-plugin
module.exports = {"as-seen-on":"as-seen-on_as-seen-on__mkrkV","hidden":"as-seen-on_hidden__3Xvf3","animated":"as-seen-on_animated__3lOAi"};